import React from 'react'
import { Link } from 'react-router-dom'

const Admissionbtn = () => {
  return (
    <>
      <Link to="/admission" className="fixed z-[9999] px-4 py-2 text-white rotate-90 bg-yellow-600 shadow-md top-1/3 -right-10">
        Admission
      </Link>
    </>
  )
}

export default Admissionbtn